export default class MyCosmoMenu {
    constructor($sidebar) {
        this.$sidebar = $sidebar;
        this.$toggle = $sidebar.querySelector('[data-my-cosmo-menu-toggle]');
        this.$menu = $sidebar.querySelector('[data-my-cosmo-menu]');
        this.desktopQuery = window.matchMedia('(min-width: 768px)');

        this._bind();
        this._setOpen(false);
    }

    _bind() {
        if (!this.$toggle || !this.$menu) {
            return;
        }

        this.$toggle.addEventListener('click', () => {
            this._setOpen(!this.$sidebar.classList.contains('is-menu-open'));
        });

        const handleDesktopChange = (event) => {
            if (event.matches) {
                this._setOpen(false);
            }
        };

        if (typeof this.desktopQuery.addEventListener === 'function') {
            this.desktopQuery.addEventListener('change', handleDesktopChange);
        } else {
            this.desktopQuery.addListener(handleDesktopChange);
        }

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this._setOpen(false);
            }
        });
    }

    _setOpen(isOpen) {
        if (!this.$toggle || !this.$menu) {
            return;
        }

        this.$sidebar.classList.toggle('is-menu-open', isOpen);
        this.$toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
}
